export default __webpack_public_path__ + "adc113d823826784cf09b1fb4e7b1d37.svg";